<template>

    <div class="bg-white h-full flex items-center">
        <Image src="/page-4.jpg" class="w-full" />
        <a href="https://carparc.carbucks.com.au/externals/protect-dealer-rate-chart.html" target="_blank"
            class="absolute w-[22vw] h-[21vw] left-[31%] mt-[4vw] cursor-pointer">
        </a>
    </div>

</template>